module.exports = __webpack_public_path__ + "img/prv-icon.717d064a.png";